import React, { PropsWithChildren } from 'react'
import { remCalc } from 'utils'

interface ICodeProps {
  style?: React.CSSProperties
}

export const Code: React.FC<PropsWithChildren<ICodeProps>> = ({
  style = {},
  children,
}) => (
  <code
    style={{
      padding: remCalc(10),
      fontSize: remCalc(10),
      ...style,
    }}
  >
    {children}
  </code>
)

Code.displayName = 'Content.Code'
